const SvgSafariPinnedTab = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200">
    <path d="M0 100v100h200V0H0v100zm113-55c17.4 4.2 31.2 15.6 38.7 32 4.3 9.5 5 15.7 4.9 48.5l-.1 31h-113l-.1-32c0-34.4.4-38.1 5.7-49.3C60.2 51.9 87.7 38.9 113 45z" />
  </svg>
);

export default SvgSafariPinnedTab;
